import { handleActions } from 'redux-actions';
import { push } from "react-router-redux";
import { initialize as initializeForm } from 'redux-form';
import { NotificationManager } from "react-notifications";
import { api } from "api";

const SUBMIT = 'LOGIN_SUBMIT';
const LOADER = 'LOGIN_LOADER';
const ME = 'LOGIN_ME';

export const constants = {
    SUBMIT,
};

// ------------------------------------
// Pure Actions
// ------------------------------------

export const setLoader = loader => ({
    type: LOADER,
    loader,
});

export const setMe = me => ({
    type: ME,
    me,
});

// ------------------------------------
// Actions
// ------------------------------------

export const onSubmit = (data = {}) => (dispatch, getStore) => {
    dispatch(setLoader(true));
    api.post('user/token', data).then((response) => {
        localStorage.setItem('token', response.token);
        dispatch(initializeForm('profile', response.user));
        dispatch(setMe(response.user));
        dispatch(push("/ordenes"));
    }).catch((err) => {
        NotificationManager.error(err.detail, 'ERROR', 0);
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

export const getMe = () => (dispatch) => {
    api.get('/user/me').then(me => {
        dispatch(initializeForm('profile', me));
        dispatch(setMe(me));
    })
        .catch(() => {
    }).finally(() => {});
};

export const logOut = () => (dispatch) => {
    api.post('/user/logout').then(() => {
    }).catch(() => {
    }).finally(() => {});
    localStorage.removeItem('token');
};


export const sendRecover = (data) => (dispatch) => {
    const email = data.email;
    dispatch(setLoader(true));
    api.post('user/pass_reset_mail', {email}).then(res =>{
        NotificationManager.success('El correo para recuperar la contraseña ha sido enviada, por favor revisa tu correo');
    }).catch(err => {
        NotificationManager.error('A ocurrido un error al enviar el correo para recuperar la contraseña, por favor intenta de nuevo.', 'ERROR');
    }).finally(()=>{
        dispatch(setLoader(false));
    });
};
export const resetPassword = (data) => (dispatch) => {
    dispatch(setLoader(true));
    api.post('user/pass_reset', data).then(res =>{
        NotificationManager.success('Tu contraseña ha sido reestablecida correctamente');
        dispatch(push('/login'));
    }).catch(err => {
        NotificationManager.error((err && err.detail) ? err.detail : 'Ocurrio un error en el reseteo de contraseña, por favor intente de nuevo.' , 'ERROR');
    }).finally(()=> {
        dispatch(setLoader(false));
    });
};


export const actions = {
    onSubmit,
    logOut,
    sendRecover,
    resetPassword
};

export const reducers = {
    [LOADER]: (state, { loader }) => {
        return {
            ...state,
            loader,
        };
    },
    [ME]: (state, { me }) => {
        return {
            ...state,
            me,
        };
    },
};

export const initialState = {
    loader: false,
    me: {},
};

export default handleActions(reducers, initialState);
